import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { CALENDAR_ROUTE, CALENDAR_TRIAL_ROUTE, HOME_ROUTE } from '../../../app/router/routes'
import { useAppSelector } from '../../../app/store/store'
import { FEATURES, FEATURE_SECTIONS, hasFeature } from '../../../entities/my'
import { LayoutPages } from '../../layoutPages'
import classes from './calendarLayout.module.scss'

export default function CalendarLayoutPage() {

    const {my} = useAppSelector(s => s.myReducer)
    const location = useLocation()
    const isTrialCalendar = location.pathname.startsWith(CALENDAR_TRIAL_ROUTE.path)
    const canViewLessonCalendar = hasFeature(my, FEATURE_SECTIONS.CALENDAR)
    const canViewTrialCalendar = hasFeature(my, FEATURE_SECTIONS.TRIAL_LESSONS)
        && hasFeature(my, FEATURES.TRIAL_LESSONS.CALENDAR_READ)

    if(isTrialCalendar && !canViewTrialCalendar){
        return <Navigate to={canViewLessonCalendar ? CALENDAR_ROUTE.path : HOME_ROUTE.path} replace />
    }

    if(!isTrialCalendar && !canViewLessonCalendar){
        return <Navigate to={canViewTrialCalendar ? CALENDAR_TRIAL_ROUTE.path : HOME_ROUTE.path} replace />
    }

    if(!canViewLessonCalendar && !canViewTrialCalendar){
        return <Navigate to={HOME_ROUTE.path} replace />
    }

    return (
        <LayoutPages title={CALENDAR_ROUTE.name}>
            <section className={classes.calendarPage}>
                <section className={classes.calendarControlPanel}>
                    <section className={classes.heading}>
                        <h1 className={classes.title}>
                            Календарь занятий
                        </h1>
                        <p className={classes.subtitle}>
                            Управление расписанием и занятиями. Время отображается по МСК.
                        </p>
                    </section>
                </section>

                <Outlet />
            </section>
        </LayoutPages>
    )
}
